import React from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import {
    ReadyToOrderPostModel,
    PurchaseDecisionMaker,
    PurchaseTimeline,
} from '../swagger-clients/s365-dashboard-v2-api-clients.service';
import { Field, Label, Radio, RadioGroup, tokens, makeStyles } from "@fluentui/react-components";
import { S365Button } from "./s365-button/s365-button.component";
import { GetReadyToOrderClient } from '../services/dashboard.service';
import { processServerError } from '../utils/helpers/error.helper';
import styles from './paramater-picker-next/parameter-picker-next.style.scss';



type RequestViewPricingFormProps = {
    onSubmit: () => void;
};

export const RequestViewPricingForm: React.FC<RequestViewPricingFormProps> = ({ onSubmit }) => {

    const [isRequestSubmitted, setIsRequestSubmitted] = React.useState<boolean>(false);
    const { control, handleSubmit, formState: { errors } } = useForm<ReadyToOrderPostModel>({
        defaultValues: new ReadyToOrderPostModel(),
    });

    const onFormSubmit: SubmitHandler<ReadyToOrderPostModel> = async data => {
        try {
            setIsRequestSubmitted(true);
            const client = GetReadyToOrderClient();

            await client.submitReadyToOrderForm(data);
            onSubmit();

        } catch (error) {
            processServerError(error, undefined, "An error occurred while submitting request to view pricing.");
        } finally {
            setIsRequestSubmitted(false);
        }
    };

    return (
        <div className="input-form" >
            <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '16px', alignSelf:"center" }}>Request to view pricing</h2>
            <form onSubmit={handleSubmit(onFormSubmit)} style={{ width: "100%", maxWidth: 520 }}>
                <div className="input-form-item" >
                    <Field
                        label={<b style={{ color: 'white' }}>Are you the purchase decision maker ?</b>}
                        validationState={errors.purchaseDecisionMaker ? 'error' : undefined}
                        validationMessage={errors.purchaseDecisionMaker ? <span style={{ color: 'white' }}>This question is required</span> : undefined}
                        style={{ marginBottom: tokens.spacingVerticalMNudge, color: 'white' }}>
                        <Controller
                            control={control}
                            name="purchaseDecisionMaker"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <RadioGroup
                                    className="input-field-radio"
                                    value={String(field.value)}
                                    onChange={(ev, data) => field.onChange(Number(data.value))}
                                    disabled={isRequestSubmitted}
                                >
                                    <Radio className='radio-white' value={String(PurchaseDecisionMaker.Yes)} label="Yes, I own the decision" />
                                    <Radio className='radio-white' value={String(PurchaseDecisionMaker.InfluenceDecision)} label="I influence the decision" />
                                    <Radio className='radio-white' value={String(PurchaseDecisionMaker.SomeoneElse)} label="Someone else decides" />
                                </RadioGroup>
                            )}
                        />
                    </Field>
                </div>

                <div className="input-form-item" >
                    <Field
                        label={<b style={{ color: 'white' }}>When are you planning to make a purchase?</b>}
                        validationState={errors.purchaseTimeline ? 'error' : undefined}
                        validationMessage={errors.purchaseTimeline ? <span style={{ color: 'white' }}>This question is required</span> : undefined}
                        style={{ marginBottom: tokens.spacingVerticalMNudge, color: 'white' }}>
                        <Controller
                            control={control}
                            name="purchaseTimeline"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <RadioGroup
                                    className="input-field-radio"
                                    value={String(field.value)}
                                    onChange={(ev, data) => field.onChange(Number(data.value))}
                                    disabled={isRequestSubmitted}
                                >
                                    <Radio className='radio-white' value={String(PurchaseTimeline.Immediately)} label="Immediately" />
                                    <Radio className='radio-white' value={String(PurchaseTimeline.OneToThreeMonths)} label="Within 1–3 months" />
                                    <Radio className='radio-white' value={String(PurchaseTimeline.ThreePlusMonths)} label="3+ months" />
                                    <Radio className='radio-white' value={String(PurchaseTimeline.JustResearching)} label="Just researching" />
                                </RadioGroup>
                            )}
                        />
                    </Field>
                </div>

                <div className="input-form-item" style={{ justifyContent: 'center', display: 'flex' }}>
                    <div style={{ width: '100%',textAlign: 'center' }}>
                        <S365Button size="large" 
                        type="submit" 
                        isLoading={isRequestSubmitted} 
                         disabled={isRequestSubmitted}>View Pricing</S365Button>
                    </div>
                </div>
            </form>
        </div>
    );
};
